import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import ToolBar from "./ToolBar";
import ReceiptsList from "./ReceiptsList";
import { fetchReceipts } from "../../../redux/actions/receipt";
import { fetchParkingPlaces } from "../../../redux/actions/parkingPlace";
import { forwardReceipt } from "../../../redux/actions/receipt";
import { Skeleton } from "@mui/material";
import ReceiptDetail from "../../../components/modal/Receipt"
import ReceiptForward from "../../../components/modal/Receipt/forward"
import { t } from "i18next";
import PDSSnackbar from "../../../components/common/Snackbar";
import { getDateMonthAgo, prepareExportCsv } from "../../../utils";
import { useDebounce } from "../../../hooks/useDebounce";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

function BackOfficeReceipt(props) {
    const {
        userUseCases,
        receipts,
        parkingPlaces,
        fetchReceipts,
        fetchParkingPlaces,
        isFetchingAllList,
        forwardReceipt,
        resendError
    } = props;

    const [isFetchedReceipts, setIsFetchedReceipts] = useState(false);
    const [isFetchingParkingPlaces, setIsFetchingParkingPlaces] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState({ dateFrom: getDateMonthAgo(), parkingActiveId: searchParams.get("parkingActiveId") });
    const [selectedPlace, setSelectedPlace] = useState();
    const [table, setTable] = useState(false);
    const [parkingPlacesValues, setParkingPlacesValues] = useState();
    const [openDetail, setOpenDetail] = useState(false);
    const [receiptDetail, setReceiptDetail] = useState({});
    const [openForward, setOpenForward] = useState(false);
    const [receiptForward, setReceiptForward] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [error, setError] = useState("");
    const { t, i18n } = useTranslation();
    const fetchReceiptsDebounced = useDebounce((filter) => {
        fetchReceipts(filter.selectedPlace ? filter.selectedPlace.key : null,
                filter.query,
                filter.state,
                filter.fiscalizationState,
                filter.parkingActiveId,
                filter.dateFrom,
                filter.dateTo)
            .then(() => {
                setIsFetchedReceipts(true);
            })
            .catch((err) => {
                console.log(err);
                setIsFetchedReceipts(false);
            });
    }, 200, [fetchReceipts]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!isFetchedReceipts) {
            fetchReceiptsDebounced(filter)
        }

        if (!isFetchingParkingPlaces) {
            fetchParkingPlaces()
                .then(() => {
                    setIsFetchingParkingPlaces(true);
                })
                .catch((err) => {
                    console.log(err);
                    setIsFetchingParkingPlaces(false);
                });
        }
    }, [
        fetchReceipts,
        filter,
        isFetchedReceipts,
        fetchParkingPlaces,
        isFetchingParkingPlaces
    ]);

    useEffect(() => {
        console.log('resendError', resendError);
        if (resendError.response?.data?.status !== undefined) {
            let args = resendError.response?.data?.errorParams;
            if (resendError.response?.data?.errorCode) {
                setError(
                    t(resendError.response?.data?.errorCode, {
                        args: args,
                    })
                );
            } else {
                setError(t("UNKNOWN_ERROR"));
            }
            setSnackbarOpen(true);
        }
    }, [resendError])

    const handleFilter = (item) => (value) => {
        if (value?.target?.value != undefined) {
            setFilter({ ...filter, [item]: value.target.value ? value.target.value : '' });
        } else {
            setFilter({ ...filter, [item]: value });
        }

        if (item === 'dateFrom' || item === 'dateTo') {
            try {
                new Date(value).toISOString();
                setIsFetchedReceipts(false);
            } catch (error) {
            }
        } else {
            setIsFetchedReceipts(false);
        }
    };

    const handleSelectedPlace = (value) => {
        setSelectedPlace(value);
        setFilter({ ...filter, selectedPlace: value });
        setIsFetchedReceipts(false);
    }

    const handleReceiptDetail = (data) => {
        setReceiptDetail(data);
        setOpenDetail(true);
    }

    const hadleCloseDetail = () => {
        setOpenDetail(false);
    }

    const handleReceiptForward = (data) => {
        setReceiptForward(data);
        setOpenForward(true);
    }

    const hadleCloseForward = () => {
        setOpenForward(false);
    }

    const handleFowrard = (receipt, email) => {
        // console.log('handleFowrard', receipt, email);
        forwardReceipt(receipt, email)
            .then(() => {

            })
            .catch((err) => {
                console.log("forwardReceipt error", err);
            });
        setOpenForward(false);
    }

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbarOpen(false);
        setError(null);
        dispatch({ type: "RECEIPT_FETCH_FAIL_CLEAR" });
    };


    useEffect(() => {
        if (parkingPlaces) {
            setParkingPlacesValues(
                parkingPlaces.map((a) => {
                    return { value: a.parkingPlaceId, label: a.name, key: a.parkingPlaceId };
                }),
            );
        }
    }, [parkingPlaces]);

    return (
        <>
            <PDSSnackbar
                open={snackbarOpen}
                onClose={handleCloseSnackbar}
                severity={"error"}
                message={error}
                position="TOP"
            />
            {!isFetchingAllList ? (
                <ToolBar
                    userUseCases={userUseCases}
                    filter={filter}
                    handleFilter={handleFilter}
                    parkingPlaces={parkingPlacesValues}
                    selectedPlace={selectedPlace}
                    handleSelectedPlace={handleSelectedPlace}
                    table={table}
                    setTable={setTable}
                    prepareExportCsv={prepareExportCsv(receipts, t, i18n)}
                />
            ) : (
                <Skeleton
                    height={200}
                    sx={{
                        width: "86%",
                        marginLeft: "30px",
                    }}
                    animation="wave"
                />
            )}

            {!isFetchingAllList ? (
                <div>
                    <ReceiptsList
                        userUseCases={userUseCases}
                        receipts={receipts}
                        isLoading={isFetchingAllList}
                        table={table}
                        handleReceiptDetail={handleReceiptDetail}
                        handleReceiptForward={handleReceiptForward}
                    />
                </div>
            ) : (
                <Skeleton
                    variant="rounded"
                    height="calc(100vh - 200px)"
                    sx={{
                        width: "86%",
                        marginLeft: "30px",
                    }}
                    animation="wave"
                />
            )}

            <ReceiptDetail
                open={openDetail}
                handleClose={hadleCloseDetail}
                receiptDetail={receiptDetail}
            />

            <ReceiptForward
                open={openForward}
                handleClose={hadleCloseForward}
                handleFowrard={handleFowrard}
                receipt={receiptForward}
            />
        </>
    );
}

const mapStateToProps = (store) => ({
    userUseCases: store.authData.userUseCases,
    receipts: store.receiptData.receipts,
    parkingPlaces: store.parkingPlaceData.parkingPlaces,
    isFetchingAllList: store.usersData.isFetchingParkingList,
    resendError: store.receiptData.errors,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchReceipts,
            fetchParkingPlaces,
            forwardReceipt,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeReceipt);
